import { TUrlParam } from "src/types/utils";

export enum EStudentProgressQueryKeys {
  getChapterStudentProgress = "getChapterStudentProgress",
  updateChapterStudentProgress = "updateChapterStudentProgress",
  getHomeworkStudentProgress = "getHomeworkStudentProgress",
  updateHomeworkStudentProgress = "updateHomeworkStudentProgress",
  getStudentProgress = "getStudentProgress",
  getStudentProgressByType = "getStudentProgressByType",
  uploadAudio = "uploadAudio",
}

export const STUDENT_PROGRESS_ENDPOINTS = {
  CHAPTER_STUDENT_PROGRESS: (
    courseId: TUrlParam,
    lessonId: TUrlParam,
    chapterId: TUrlParam,
    studentId: TUrlParam
  ): string =>
    `/student-progress/${studentId}/courses/${courseId}/lessons/${lessonId}/chapters/${chapterId}/exercises`,
  HOMEWORK_STUDENT_PROGRESS: (
    courseId: TUrlParam,
    lessonId: TUrlParam,
    homeworkId: TUrlParam,
    studentId: TUrlParam
  ): string =>
    `/student-progress/${studentId}/courses/${courseId}/lessons/${lessonId}/homework/${homeworkId}/exercises`,
  MOVE_TO_HOMEWORK: (
    studentId: TUrlParam,
    courseId: TUrlParam,
    lessonId: TUrlParam
  ): string =>
    `/student-progress/${studentId}/courses/${courseId}/lessons/${lessonId}/history/move-to-homework`,
  MOVE_TO_CLASS: (
    studentId: TUrlParam,
    courseId: TUrlParam,
    lessonId: TUrlParam
  ): string =>
    `/student-progress/${studentId}/courses/${courseId}/lessons/${lessonId}/history/move-to-class`,
  STUDENT_PROGRESS: "/progress",
  STUDENT_PROGRESS_BY_TYPE: "/progress/by-type",
  AUDIO_UPLOAD: "/student-progress/audio",
  AUDIO_DOWNLOAD: (reference: string): string =>
    `/student-progress/audio/${encodeURIComponent(reference)}`,
};
